import { createI18n } from 'vue-i18n';

const messages = {
  es: {
    welcome: '¡Bienvenido a TreffPunkt!',
    formularios: 'Formularios',
    listaFormularios: 'Lista de Formularios',
    titulo: 'Título',
    creadoPor: 'Creado Por',
    creacion: 'Creación',
    ultMod: 'Ult. Mod.',
    buscarFormularios: 'Buscar formularios',
    observacion: 'Observacion',
    tipo: 'Tipo',
    completar: 'Completar',
    editar: 'Editar',
    darAcceso: 'Dar Acceso',
    eliminar: 'Eliminar',
    compartir: 'Compartir',
    evaluado: 'Evaluado',
    materia: 'Materia',
    observaciones: 'Observaciones',
    comentario: 'Comentario',
    caracteres: 'caracteres',
    enviar: 'Enviar',
    cancelar: 'Cancelar',
    crearNuevoFormulario: 'Crear Nuevo Formulario',
    nombreFormulario: 'Nombre del Formulario',
    descripcion: 'Descripción',
    accesoRestringido: 'Acceso Restringido',
    agregarEvaluado: 'Agregar Evaluado',
    agregarEleccionMateria: 'Agregar Elección de Materia',
    agregarObservacion: 'Agregar Observación',
    guardar: 'Guardar',
    seleccionarTipoATraer: '(Seleccionar el tipo)',
    ingreseTituloObservacion: 'Ingrese el título de la observación',
    CondicionObservada: 'Condición Observada',
    Fecha: 'Fecha',
    Hora: 'Hora',
    Opciones: 'Opciones',
    Rango: 'Rango',
    TextoCorto: 'Texto Corto',
    agregarComentario: 'Agregar Comentario',
    obligatorio: 'Obligatorio',
    profesor: 'Profesor',
    familiar: 'Familiar',
    alumno: 'Alumno',
    agregar: 'Agregar',
    agregarItem: 'Agregar Item',
    copiar: 'Copiar',
    copiarEnlaceParaCompartir: 'Copia el enlace para compartirlo',
    lector: 'Lector',
    editor: 'Editor',
    completador: 'Completador',
    agregarPersonas: 'Agregar personas',
    permisosLector: 'Puede completar y leer los resultados del formulario',
    permisosEditor: 'Puede completar, responder, editar, dar acceso y eliminar el formulario',
    permisosCompletador: 'Puede completar con datos el formulario',
    personasConAcceso: 'Personas con Acceso',
    cerrarSesion: 'Cerrar Sesión',
    permisos: 'Permisos',
    volver: 'Volver',
    buscarPersona: 'Buscar Persona',
    seleccionaFecha: 'Selecciona una fecha',
    seleccionaHora: 'Selecciona una hora',
    formEnviadoExitosamente: 'Formulario enviado exitosamente',
    seleccionarValorRango: 'Debes seleccionar un valor del rango para la observación',
    editarFormulario: 'Editar Formulario',
    por: 'por',
    subirArchivo: 'Subir Archivo',
    tamanoMaximo: 'Tamaño Máximo',
    archivoSeleccionado: 'Archivo Seleccionado',
    Archivo: 'Archivo',
    cursoGrupo: 'Curso o Grupo',
    buscar: 'Buscar',
    Evaluado: 'Evaluado',
    personalizado: 'Personalizado',
    agregarPersona: 'Agregar Persona',
    loginGoogle: 'Iniciar Sesion con Google',
    porfavorLogin: 'Por favor inicie sesión',
    personasSeleccionadas: 'Personas Seleccionadas',
    anterior: 'Anterior',
    siguiente: 'Siguiente',
    confirmar: 'Confirmar',
    seguroEliminarForm: 'Está seguro de que desea eliminar este formulario',
    Si: 'Si',
    No: 'No',
    "No Observable": 'No Observable',
    min: 'Min',
    max: 'Max',
    step: 'Paso',
    todosLosFormularios: 'Mostrar todos los Formularios',
    personas: 'Personas',
    beneficios: 'Beneficios para empleados',
    misDatos: 'Mis Datos',
    apellido: 'Apellido',
    nombre: 'Nombre',
    emails: 'Emails',
    dniPasaporte: 'DNI/Pasaporte',
    estadoCivil: 'Estado Civil',
    genero: 'Género',
    masculino: 'Masculino',
    femenino:'Femenino',
    noBinario:'No Binario',
    prefieroNoDecirlo: 'Prefiero no decirlo',
    fechaNacimiento: 'Fecha de Nacimiento',
    paisDeNacimiento: 'Pais de Nacimiento',
    nacionalidades: 'Nacionalidades',
    lenguasMaternas: 'Lenguas Maternas',
    domicilio:'Domicilio',
    localidad: 'Localidad',
    codigoPostal:'Código Postal',
    barrio: 'Barrio',
    contacto: 'Contacto',
    celular: 'Celular',
    telefonoFijo: 'Teléfono Fijo',
    contactoDeEmergencia:'Contacto de Emergencia',
    telefonoCelular: 'Teléfono/Celular',
    provinciaDeNacimiento: 'Provincia de Nacimiento',
    agregarEmail: 'Agregar otro email',
    agregarNacionalidad: 'Agregar Nacionalidad',
    agregarLenguaMaterna: 'Agregar Lengua Materna',
    emailProfesional: 'Email Profesional',
    emailsPersonales: 'Email Personal (Domicilio Electrónico Constituido)',
    vinculoRelacion: 'Vínculo/Relación',
    abuelo: 'Abuelo/a',
    amigo: 'Amigo/a',
    cuidador: 'Cuidador/a',
    hijo: 'Hijo/a',
    nieto: 'Nieto/a',
    padreMadre: 'Padre/Madre',
    pareja: 'Pareja',
    primo: 'Primo/a',
    sobrino: 'Sobrino/a',
    socio: 'Socio',
    tio: 'Tio/a',
    tutor: 'Tutor/a',
    vecino: 'Vecino/a',
    nivelSector: 'Nivel/Sector',
    verPerfil: 'Ver Perfil',
    datosInternos: 'Datos Internos',
    estado: 'Estado',
    roles: 'Roles',
    Retirado: 'Retirado',
    Activo: 'Activo',
    Egresado: 'Egresado',
    Inactivo:'Inactivo',
    "Soltero(a)": "Soltero(a)",
    "Casado(a)": "Casado(a)",
    "Divorciado(a)": "Divorciado(a)",
    "Viudo(a)": "Viudo(a)",
    datosPersona: 'Datos de Persona',
    buscarPersonas:'Buscar Personas',
    buscarPorNombre: 'Buscar por nombre',
    searchValuesPersonas:'Podes buscar por: Apellido, Nombre y Email',
    conAccesoRestringido: 'Acceso Restringido',
    anonimo: 'Anónimo',
    formAnonimo: 'Este formulario es anónimo.',
    rol: 'Rol',
    agregarPermisos: 'Agregar Permisos',
    accesos: 'Accesos',
    jefe: 'Jefe',
    buscarRoles: 'Buscar Roles',
    nombreRol: 'Nombre de Rol',
    agregarRol: 'Agregar Rol',
    agregarPermiso: 'Agregar Permiso',
    sinPermisos: 'Sin Permisos',
    personasQuePuedenVerLaObservacion: 'Personas que pueden ver la observacion',
    obsOculta: 'Observacion oculta',
    obsObligatoria: 'Observacion obligatoria',
    subordinados: 'Subordinados',
    todos: 'Todos',
    conRespuesta: 'Con Respuestas',
    responder: 'Responder',
    copiarEnlaceParaCompartirParaResponder: 'Copiar el enlace para compartir y que otros puedan responder valores ya ingresados',
    personaAResponder: 'Persona a responder',
    valorIngresado: 'Valor Ingresado',
    graficos: 'Gráficos',
    respuestas: 'Respuestas',
    respuestaDe: 'Respuesta de',
    respondedor: 'Respondedor',
    permisosRespondedor: 'Puede Responder y Completar un Formulario',
    galeriaDeFotos: 'Galeria de Fotos',
    nro: 'Nro.',
    departamento: 'Departamento',
    piso: 'Piso',
    exportarResultados: 'Exportar Resultados',
    conEnvioDeEmail: 'Con envio de email',
    quienesLesApareceParaResponder:'Personas pueden responder a',
    conEdicionDeCompletado: 'Con edición de completado',
    conVisualizacionRestringida: 'Con visualización restringida',
    mostrarDatosInternos: 'Mostrar Datos Internos',
    añadirNuevaGaleria: 'Añadir nueva galería',
    de: 'de',
    laspropias: 'Las propias',
    queRespuestasPuedenEditar: 'Que respuestas pueden editar',
    archivosSubidos: 'Archivos Subidos',
    provincia: 'Provincia',
    asignarSiguienteEstado: 'Asignar Siguiente Estado',
    Rechazado: 'Rechazado',
    Aprobado: 'Aprobado',
    Pendiente: 'Pendiente',
    autorizar: 'Autorizar',
    conAutorizaciones: 'Con Autorizaciones',
    autorizaciones: 'Autorizaciones',
    ocultarHistorialAutorizaciones: 'Ocultar Historial Autorizaciones',
    aQuienesAutorizan: 'A Quienes Autorizan',
    historialDeEstadosDeAutorizacion: 'Historial de estados de autorización',
    Finalizado: 'Finalizado',
    agregarPor: 'Agregar por',
    personaEspecifica: 'Persona Específica',
    grupo: 'Grupo',
    estados: 'Estados',
    autorizador: 'Autorizador',
    autorizarDesordenado: 'Autorizar Desordenado',
    enviarEmailCambioEstado: 'Enviar email por cambio de estado',
    añadirNuevoMenu: 'Añadir nuevo Menú',
    menu: 'Menú',
    archivo: 'Archivo',
    enviarEmailAAutorizadores: 'Enviar email a autorizadores',
    enviarEmailResumenDiario: 'Enviar email resumen diario',
    sePuedenAutoAutorizar: 'Se pueden auto autorizar',
    noAprobarAutomaticamente: 'No aprobar automaticamente',
    nombreGrupo: 'Nombre grupo',
    grupos: 'Grupos',
    opciones: 'Opciones',
    opcion: 'Opcion',
    nombreLista: 'Nombre lista',
    personasRelacionadas: 'Personas Relacionadas',
    responsable: 'Persona encargada',
    agregarLista: 'Agregar lista',
    creador: 'Creador',
    nuevoFormulario: 'Nuevo Formulario',
    hola: 'Hola',
    cumpleaños: 'Cumpleaños',
    guiaDeInternos: 'Guía de Internos',
    resAcademicos: 'Resultados Académicos',
    formulariosDescr: 'Requerimientos de uso interno',
    menuDescr: 'Almuerzos del mes',
    guiaDeInternosDescr: 'Números de teléfono de las oficinas',
    goetheDoksDescr: 'Base de conocimientos',
    resAcademicosDescr: 'Evaluaciones de alumnos',
    calendario: 'Calendario',
    hoy: 'Hoy',
    Lunes: 'Lunes',
    Martes: 'Martes',
    Miercoles: 'Miércoles',
    Jueves: 'Jueves',
    Viernes: 'Viernes',
    Sabado: 'Sábado',
    Sábado: 'Sábado',
    Domingo: 'Domingo',
    Mañana: 'Mañana',
    verTodosLosMenus: 'Ver todos los Menús',
    inicio: 'Inicio',
    verCalendario: 'Ver Calendario',
    noCumplesHoy: 'No se encontraron cumpleaños para el dia de hoy',
    noCumplesSemana: 'No se encontraron cumpleaños para la semana',
    años: 'años',
    minimoAutorizacion: 'Mínimo autorización',
    darAccesoAlCompletar: 'Dar acceso al completar',
    tipoDeAccesoADar: 'Tipo de acceso a dar',
    reiniciarPorDefecto: 'Reiniciar por defecto',
    personalizarColor: 'Personalizar color',
    elegiTuColorAccent: 'Elegí tu color accent',
    digitalizacion: 'Digitalización',
    digitalizacionDescr: 'Centro de recursos y aplicaciones digitales',
    secretaria: 'Secretaría',
    primaria: 'Primaria',
    secundaria: 'Secundaria',
    galeriaDeFotosDescr: 'Galeria de Fotos Institucionales',
    gruposConAcceso: 'Grupos con acceso',
    noHayForms:'Parece que no tenes formularios compartidos',
    buscarLista: 'Buscar lista de un grupo',
    cargo: 'Cargo',
    noDocsDisponibles: 'No hay documentos disponibles',
    seguroEliminarDoc: '¿Está seguro de que desea eliminar este documento?',
    seguroEliminarDocMasivo: '¿Está seguro de que desea eliminar estos documentos de manera Masiva?',
    verDocumento: 'Ver Documento',
    leido: 'Leído',
    documento: 'Documento',
    fechaCreacion: 'Fecha Creacion',
    fecha: 'Fecha',
    fechaDocumento: 'Fecha Documento',
    cerrar: 'Cerrar',
    cargandoDocs: 'Cargando documentos',
    subirDocumentos: 'Subir documentos',
    urlCarpeta: 'URL de la Carpeta',
    Boletines: 'Boletines',
    Informes: 'Informes',
    Facturas: 'Facturas',
    tipoDocumento: 'Tipo de documento',
    tituloDocumento: 'Titulo del documento',
    subirDocsGoetheApp: 'Subir documentos a GoetheApp',
    buscarUsuariosFidu: 'Buscar usuarios de Fidu',
    pegaLinkDrive: 'Pega el link de la carpeta de Drive',
    subidasFidu: 'Subidas a GoetheApp',
    "Con errores": 'Con errores',
    Completado: 'Completado',
    Error: 'Error',
    usuariosConectados: 'Usuarios conectados',
    agregarSubgaleria: 'Agregar Subgalería',
    urlRedireccion: 'URL de redirección',
    imagenPortada: 'Imagen de Portada',
    nuevaGaleria: 'Nueva Galería',
    galeriaHabilitada: 'Galería habilitada',
    subGaleriaHabilitada: 'SubGalería habilitada',
    buscarGalerias: 'Buscar Galerías',
    datosPersonales: 'Datos personales',
    rolesYPermisos: 'Roles y Permisos',
    gruposYListas: 'Grupos y Listas',
    volverAPersonas: 'Volver a personas',
    asignaturas: 'Asignaturas',
    permisosAsignadosEnUnRol: 'Permisos ya asignados en un Rol',
    permisosAsignables: 'Permisos asignables',
    ayuda: 'Ayuda',
    noEstaEnNingunaLista: 'No esta en ninguna lista',
    duplicar: 'Duplicar',
    misRespuestas: 'Mis respuestas',
    noTenesRespuestas: 'No tenes respuestas',
    legajo: 'Legajo',
    filtros: 'Filtros',
    nivel: 'Nivel',//Es el nivel educativo
    subido: 'Subido',
    general: 'General',
    instructivo: 'Instructivo',
    configuracion: 'Configuración',
    descripcionAnonimo: 'Si esta activo las respúestas se vuelven anonimas. No se guarda quien las completo. Tener en cuenta que si ya se completo el formulario antes de anonimizar el dato de lo ya completado queda, solo se oculta visualmente. A los nuevos requerimientos no se les guarda quien lo completo.',
    descripcionAccesoRestringido: 'Si esta activo solo se le permite completar a los usuarios con acceso completador.',
    descripcionEdicionCompletado: 'Si esta activo se le permite a los usuarios editar las respuestas. Se puede elegir a quien tienen permitido editar.',
    descripcionVisualizacionRestringida: 'Si esta activo limita las respuestas que se pueden ver en la pagina de visualizacion del formulario, seas Lector, Editor o Creador.',
    descripcionAutorizaciones: 'Si esta activo habilita las autorizaciones a los requerimientos.',
    descripcionDarAccesoAlCompletar: 'Si esta activo y un usuario sin acceso al formulario lo completa, se le agrega automaticamente el acceso de completador. Esto sirve para que les aparezca a los usuarios el formulario en la seccion de Mis Formularios. Importante el acceso a completar no debe estar restringido.',
    descripcionConRespuesta: 'Si esta activo, le permite a los lectores responder a los requerimientos. Dependiendo que se selecciona, podran responder a ciertas personas.',
    descripcionAutorizarDesordenado: 'Esto permite que los pasos de Autorizacion se puedan hacer en desorden',
    descripcionOcultarHistorialAutorizaciones: 'Oculta el historial de autorizaciones cuando se va a autorizar',
    pasosDeAutorizacion: 'Pasos de autorización',
    agregarPaso: 'Agregar paso',
    paso: 'Paso',
    faltanAutorizacionesPrevias: 'Faltan autorizaciones previas',
    habilitar: 'Habilitar',
    habilitado: 'Habilitado',
    deshabilitar: 'Deshabilitar',
    deshabilitado: 'Deshabilitado',
    instructivos: 'Instructivos',
    buscarInstructivos: 'Buscar Instructivos',
    codigoEmbebido: 'Código Embebido',
    fechaIngreso: 'Fecha Ingreso',
    formPublico: 'Formulario público',
    descripcionFormPublico: 'Si esta activo, muestra el Formulario a todos los usuarios en el menu de Mis Formularios',
    autorizadorGeneralDescr: 'Si tiene el borde arcoiris significa que el autorizador puede autorizar en otros Pasos/Niveles SOLO haciendo click derecho.',
    esProfesor: 'Es Profesor',
    empleado: 'Empleado',
    externo: 'Externo',
    filtrar: 'Filtrar',
    limpiarFiltros: 'Limpiar filtros',
    exportarDatos: 'Exportar Datos',
    parent: 'Padre',
    student: 'Alumno',
    teacher: 'Docente',
    executive: 'Directivo',
    preceptor: 'Preceptor',
    admin: 'Administrador',
    boletinNoticias: 'Boletines',
    nuevoInstructivo: 'Nuevo Instructivo',
    carpeta: 'Carpeta',
    noEncontramosInstructivo: 'Parece que no encontramos el instructivo que buscabas',
    noEncontramosForm: 'Parece que no encontramos el formulario que buscabas',
    errorConElServidor: 'No se puede conectar al servidor, intente de nuevo en unos minutos',
    galeria: 'Galería',
    esPublicoATodos: 'Es público para todos',
    esPublicaATodos: 'Es pública para todos',
    permisosLectorInstructivo: 'Puede ver los instructivos',
    permisosEditorInstructivo: 'Puede ver, editar y dar acceso a los instructivos',
    permisosLectorGaleria: 'Puede ver lss galerías',
    permisosEditorGaleria: 'Puede ver, editar y dar acceso a las galerías',
    noEncontramosGaleria: 'Parece que no encontramos la galeria que buscabas',
    logoEmbebido: 'Logo embebido',
    reporte: 'Reporte',
    error: 'Error',
    subir: 'Subir',
    gestionTokens: 'Gestion Tokens',
    activo: 'Activo',
    revocado: 'Revocado',
    expirado: 'Expirado',
    expira: 'Expira',
    creado: 'Creado',
    noSeEncontraronTokens: 'No se encontraron tokens',
    pagina: 'Página',
    confirmarRevocarToken: '¿Seguro que desea revocar el Token?',
    antiguo: 'Antiguo',
    clickAcaParaCompletarForm: 'Hacer click acá para completar el Formulario',
    infoPersonal: 'Información Personal',
    pasaporte: 'Pasaporte',
    infoDeContacto: 'Información de Contacto',
    origenYNacionalidad: 'Origen y Nacionalidad',
    infoInstitucional: 'Información Institucional',
    direcciones: 'Direcciones',
    localidadDeNacimiento: 'Localidad de Nacimiento',
    dni: 'DNI',
    guardarCambios: 'Guardar cambios',
    actualizarEn: 'Actualizar en',
    'N/A': 'S/R',
    desconocido: 'Desconocido',
    Enconcubinato: 'Enconcubinato',
    'Separado(a)': 'Separado(a)',
    fechaFallecimiento: 'Fecha Fallecimiento',
    ultimaActualizacion: 'Última Actualización',
    listas: 'Listas',
    sinListas: 'sinListas',
    y: 'y',
    historialRoles: 'Historial de Roles',
    asignarRol: 'Asignar Rol',
    motivo: 'Motivo',
    adminTreffpunkt: 'Admin de Treffpunkt',
    direccion: 'Dirección',
    particular: 'Particular',
    laboral: 'Laboral',
    otro: 'Otro',
    principal: 'Principal',
    direccionCompartidaCon: 'Dirección compartida con',
    direccionSeLeActualizaraTambienA: 'La dirección se le actualizará también a',
    calle: 'Calle',
    paisRequerido: 'País requerido',
    provinciaRequerida: 'La provincia es requerida',
    localidadRequerida: 'La localidad es requerida',
    calleRequerida: 'La calle es requerida',
    nroRequerido: 'El número es requerido',
    codigoPostalRequerido: 'El código postal es requerido',
    seleccionarProvincia: 'Seleccionar provincia',
    subirA: 'Subir a',
    fechaNacimientoRequerida: 'Fecha de nacimiento requerida',
    celularRequerido: 'Celular requerido',
    estadoCivilRequerido: 'Estado Civil requerido',
    generoRequerido: 'Genero requerido',
    emailRequerido: 'Email requerido',
    agregarNivelSector: 'Agregar Nivel/Sector',
    nivelSectorRequerido: 'Nivel/Sector requerido',
    nacionalidadRequerida: 'Nacionalidad requerida',
    nombreRequerido: 'Nombre requerido',
    telefonoRequerido: 'Teléfono requerido',
    relacionRequerida: 'Relación requerida',
    admintreffpunkt: 'Admin Treffpunkt',
    preferencias: 'Preferencias',
    esconderCumple: 'Esconder mi cumpleaños',
    emailDe: 'Email de',
    Responsable: 'Responsable', //Responsable Party, Persona Responsable
    alMenosUnaDireccionPrincipal: 'Al menos una dirección debe ser una dirección principal',
    idsInternosYExternos: 'IDs Internos y Externos',
    tipoPersona: 'Tipo de Persona',
    nroDni: 'Nro DNI',
    siglaUntis: 'Sigla UNTIS',
    perfilEn: 'Perfil en',
    "comision directiva": 'Comisión Directiva',
    rolOculto: 'Rol oculto',
    cicloLectivo: 'Ciclo Lectivo',
    ninguno: 'Ninguno',
    tipoDocente: 'Tipo de docente',
    jardin: 'Kindergarten',
    administracion: 'Administración',
    mantenimiento: 'Mantenimiento',
    jerarquicos: 'Jerárquicos',
    Exportadores: 'Exportadores',
    cargandoHorarios: 'Cargando horarios...',
    horarios: 'Horarios',
    horario: 'Horario',
    noSeEncontrarioHorarios: 'No se encontraron horarios.',
    jerárquico: 'Jerárquico',
    agds: 'AGDS',
    comisionDirectiva: 'Comisión Directiva',
    horarioFijo: 'Horario Fijo',
    turno: 'Turno',
    homeOffice: 'Home Office',
    presencial: 'Presencial',
    rrhh: 'RRHH',
    noResultados: 'No se encontraron resultados',
    fichadas: 'Fichadas',
    reloj: 'Reloj',
    semanaActual: 'Semana Actual',
    vacaciones: 'Vacaciones',
    horarioDeReceso: 'Horario de Receso',
    licenciaEspecial: 'Licencia Especial',
    diaExamen: 'Día Examen',
    diaEstudio: 'Día Estudio',
    embarazo: 'Embarazo',
    adlk: 'ADLK',
    bplk: 'BPLK',
    dolk: 'DOLK',
    olk: 'OLK',
    diaNoLaborable: 'Día no laborable',
    asignarDiaNoLaborablePorSectores: 'Asignar día no laborable por sectores',
    noHaySectoresDisponibles: 'No hay sectores disponibles',
    sectoresAfectados: 'Sectores afectados',
    asignarRecesoPorSectores: 'Asignar horario de receso por sectores',
    nuevoHorarioDeReceso: 'Nuevo horario de receso',
    noSeEncontraronEmpleados: 'No se encontraron empleados',
    'Ausente / Sin fichadas': 'Ausente / Sin fichadas',
    'Vacaciones': 'Vacaciones',
    'Fichadas incompletas': 'Fichadas incompletas',
    'Cumplió horario': 'Cumplió horario',
    'Horas extra': 'Horas extra',
    'Feriado': 'Feriado',
    'Cumplió las horas': 'Cumplió las horas',
    'Llegó tarde': 'Llegó tarde',
    'Se retiró antes': 'Se retiró antes',
    'Llegó tarde y se retiró antes': 'Llegó tarde y se retiró antes',
    enfermedad:'Enfermedad',
    deporte: 'Deporte',
    horaDesde: 'Hora desde',
    horaHasta: 'Hora hasta',
    periodoDesde: 'Periodo desde',
    periodoHasta: 'Periodo hasta',
    sector: 'Sector',
    practicante: 'Practicante',
    pasante: 'Pasante',
    verCarpeta: 'Ver Carpeta',
    verLogs: 'Ver Logs',
    al: 'al',
    niHorariosNiFichadas: 'No hay horarios fijos ni fichadas',
    errorPeriodoMaximo31Dias: 'El periodo máximo permitido es de 31 días',
    errorDesdeNoMayorHasta: "La fecha 'Desde' no puede ser mayor a la fecha 'Hasta'",
    buscarEmpleadoPorNombreLegajo: 'Buscar empleado por nombre o legajo',
    periodoHastaOpcional: 'Periodo hasta(Opcional)',
    diaDeLaSemana: 'Día de la semana',
    esHomeOffice: 'Es Home Office',
    todosLosDiasHabiles: 'Todos los días hábiles',
    nuevo: 'Nuevo',
    tipoLicencia: 'Tipo de licencia',
    esconderEdadCumple: 'Esconder mi edad en el cumpleaños',
    edad: 'Edad',
    nroInterno: 'Nro. Interno',
    email: 'Email',
    enero: 'Enero',
    febrero: 'Febrero',
    marzo: 'Marzo',
    abril: 'Abril',
    mayo: 'Mayo',
    junio: 'Junio',
    julio: 'Julio',
    agosto: 'Agosto',
    septiembre: 'Septiembre',
    octubre: 'Octubre',
    noviembre: 'Noviembre',
    diciembre: 'Diciembre',
    delAlumno: 'del alumno',
    completado: 'Completado',
    alerta: 'Alerta',
    eliminado: 'Eliminado',
    pendiente: 'Pendiente',
    usuarios: 'Usuarios',
    subidas: 'Subidas',
    cancelado: 'Cancelado',
    cancelarSubida: 'Cancelar subida',
    mias: 'Mías',
    todas: 'Todas',
    reservaEspacios: 'Reserva de espacios',
    inventario: 'Inventario',
    horariosBackOffice: 'Horarios Back Office',
    ausenciasSuplenciasDocentes: 'Ausencias y suplencias docentes',
    datosFaltantes: 'Datos faltantes',
    buscarDocentePorNombre: 'Buscar docente por nombre',
    seleccionarFechaSemana: 'Seleccionar fecha / semana',
    horarioDocente: 'Horario docente',
    ausencias: 'Ausencias',
    horas: 'Horas',
    justificada: 'Justificada',
    injustificada: 'Injustificada',
    sinAusenciasPeriodo: 'Sin ausencias en el periodo seleccionado',
    clasesSimultaneas: 'Clases simultáneas',
    sinCertificado: 'Sin certificado',
    verCertificado: 'Ver certificado',
    eliminarArchivosViejos: 'Eliminar archivos viejos',
    eliminarArchivosViejosConfirmacion: '¿Está seguro que quiere eliminar todos los archivos anteriores a 1 mes?',
    noSePodraVolverAtras: 'Esta acción no se podrá volver atrás y los archivos se perderán permanentemente.',
    almacenamientoTreffpunkt: 'Almacenamiento de Treffpunkt',
    cargando: 'Cargando',
    clases: 'Clases',
    aula: 'Aula',
    reemplazaA: 'Reemplaza a',
    hora: 'Hora',
    suplencias: 'Suplencias',
    suplencia: 'Suplencia',
    ausente: 'Ausente',
    sinSuplenciasPeriodo: 'Sin suplencias en el periodo seleccionado',
    seleccionarPeriodoExportar: 'Seleccione el período de quincena que desea exportar para el sector',
    exportarLicAusViaExtrAExcel: 'Exportar licencias, ausencias, viajes y horas extras a Excel',
    exportarExcel: 'Exportar a Excel',
    generando: 'Generando',
    descargar: 'Descargar',
    periodo: 'Período',
    mapasAprendizaje: "Mapas de Aprendizaje",
    instructivoHorariosBackOffice: 'Instructivo para horarios de Back Office',
    documentacion: 'Documentación',
    permiso: 'Permiso',
    categoria: 'Categoría',
    subCategoria: 'Subcategoría',
    seleccionePersona: 'Seleccione a una persona',
    asignarNuevaPersona: 'Asignar nueva persona a este permiso',
    asignar: 'Asignar',
    asignadoEl: 'Asignado el',
    sinPersonasAsignadas: 'Ninguna persona tiene asignado este permiso directamente.',
    confirmarQuitarPersona: '¿Estás seguro de que deseas remover este permiso a esta persona?',
    nombrePermiso: 'Nombre Permiso',
    personasAsignadasPorRol : 'Personas asignadas por Rol',
    personasAsignadasPorPermiso: 'Personas asignadas por Permiso',
    usuariosSinHorarioOFichadasNoApareceran: 'Usuarios sin horario asignado dentro de los ultimos 30 dias',
    recruiting: 'Contrataciones',
  },

  en: {
    welcome: 'Welcome to TreffPunkt!',
    formularios: 'Forms',
    listaFormularios: 'Forms List',
    titulo: 'Title',
    creadoPor: 'Created By',
    creacion: 'Creation',
    ultMod: 'Last Mod.',
    buscarFormularios: 'Search forms',
    observacion: 'Observation',
    tipo: 'Type',
    completar: 'Complete',
    editar: 'Edit',
    darAcceso: 'Grant Access',
    eliminar: 'Delete',
    compartir: 'Share',
    evaluado: 'Evaluated',
    materia: 'Subject',
    observaciones: 'Observations',
    comentario: 'Comment',
    caracteres: 'characters',
    enviar: 'Submit',
    cancelar: 'Cancel',
    crearNuevoFormulario: 'Create New Form',
    nombreFormulario: 'Form Name',
    descripcion: 'Description',
    accesoRestringido: 'Restricted Access',
    agregarEvaluado: 'Add Evaluated',
    agregarEleccionMateria: 'Add Subject Selection',
    agregarObservacion: 'Add Observation',
    guardar: 'Save',
    seleccionarTipoATraer: '(Select type)',
    ingreseTituloObservacion: 'Enter the observation title',
    CondicionObservada: 'Observed Condition',
    Fecha: 'Date',
    Hora: 'Time',
    Opciones: 'Options',
    Rango: 'Range',
    TextoCorto: 'Short Text',
    agregarComentario: 'Add Comment',
    obligatorio: 'Mandatory',
    profesor: 'Teacher',
    familiar: 'Family Member',
    alumno: 'Student',
    agregar: 'Add',
    agregarItem: 'Add Item',
    copiar: 'Copy',
    copiarEnlaceParaCompartir: 'Copy the link to share it',
    lector: 'Reader',
    editor: 'Editor',
    completador: 'Completer',
    agregarPersonas: 'Add people',
    permisosLector: 'Can complete and view the form results',
    permisosEditor: 'Can complete, respond, edit, grant access, and delete the form',
    permisosCompletador: 'Can fill in the form with data',
    personasConAcceso: 'People with Access',
    cerrarSesion: 'Log Out',
    permisos: 'Permissions',
    volver: 'Back',
    buscarPersona: 'Search Person',
    seleccionaFecha: 'Select a date',
    seleccionaHora: 'Select a time',
    formEnviadoExitosamente: 'Form submitted successfully',
    seleccionarValorRango: 'You must select a range value for the observation',
    editarFormulario: 'Edit Form',
    por: 'by',
    subirArchivo: 'Upload File',
    tamanoMaximo: 'Maximum Size',
    archivoSeleccionado: 'Selected File',
    Archivo: 'File',
    cursoGrupo: 'Course or Group',
    buscar:'Search',
    Evaluado: 'Evaluated',
    personalizado: 'Personalized',
    agregarPersona: 'Add Person',
    loginGoogle: 'Log in with Google',
    porfavorLogin: 'Please log in',
    personasSeleccionadas: 'Selected People',
    anterior: 'Previous',
    siguiente: 'Next',
    confirmar: 'Confirm',
    seguroEliminarForm: 'Are you sure you want to delete this form',
    Si: 'Yes',
    No: 'No',
    "No Observable": 'Not Observable',
    min: 'Min',
    max: 'Max',
    step: 'Step',
    todosLosFormularios: 'Show all Forms',
    personas: 'People',
    beneficios: 'Employee benefits',
    misDatos: 'My Data',
    apellido: 'Last Name',
    nombre: 'First Name',
    emails: 'Emails',
    dniPasaporte: 'DNI/Passport',
    estadoCivil: 'Marital Status',
    genero: 'Gender',
    masculino: 'Male',
    femenino: 'Female',
    noBinario: 'Non-Binary',
    prefieroNoDecirlo: 'Prefer not to say',
    fechaNacimiento: 'Date of Birth',
    paisDeNacimiento: 'Country of Birth',
    nacionalidades: 'Nationalities',
    lenguasMaternas: 'Mother Tongue',
    domicilio: 'Address',
    localidad: 'City',
    codigoPostal: 'Postal Code',
    barrio: 'Neighborhood',
    contacto: 'Contact',
    celular: 'Mobile',
    telefonoFijo: 'Landline',
    contactoDeEmergencia: 'Emergency Contact',
    telefonoCelular: 'Phone/Mobile',
    provinciaDeNacimiento: 'Province of Birth',
    agregarEmail: 'Add another email',
    agregarNacionalidad: 'Add Nationality',
    agregarLenguaMaterna: 'Add Mother Tongue',
    emailProfesional: 'Professional Email',
    emailsPersonales: 'Personal Email (Registered Electronic Address)',
    vinculoRelacion: 'Relationship/Link',
    abuelo: 'Grandfather/Grandmother',
    amigo: 'Friend',
    cuidador: 'Caregiver',
    hijo: 'Son/Daughter',
    nieto: 'Grandson/Granddaughter',
    padreMadre: 'Father/Mother',
    pareja: 'Partner',
    primo: 'Cousin',
    sobrino: 'Nephew/Niece',
    socio: 'Partner',
    tio: 'Uncle/Aunt',
    tutor: 'Tutor',
    vecino: 'Neighbor',
    nivelSector: 'Level/Sector',
    verPerfil: 'View Profile',
    datosInternos: 'Internal Data',
    estado: 'Status',
    roles: 'Roles',
    Retirado: 'Withdrawn',
    Activo: 'Active',
    Egresado: 'Graduated',
    Inactivo: 'Inactive',
    "Soltero(a)": 'Single',
    "Casado(a)": "Married",
    "Divorciado(a)": "Divorced",
    "Viudo(a)": "Widowed",
    datosPersona: 'Person Data',
    buscarPersonas: 'Search People',
    buscarPorNombre: 'Search by Name',
    searchValuesPersonas: "You can search by: Last Name, First Name and Email",
    conAccesoRestringido: "Restricted Access",
    anonimo: 'Anonymous',  
    formAnonimo: 'This form is anonymous.'  ,
    rol: "Role",
    agregarPermisos: "Add Permissions",
    accesos: 'Access',
    jefe: 'Boss',
    buscarRoles: 'Search Roles',
    nombreRol: 'Role Name',
    agregarRol: 'Add Role',
    agregarPermiso: 'Add Permission',
    sinPermisos: 'No Permissions',
    personasQuePuedenVerLaObservacion: 'People who can see the observation',
    obsOculta: 'Hidden observation',
    obsObligatoria: 'Mandatory observation',
    subordinados: 'Subordinates',
    todos: 'Everyone',
    conRespuesta: 'With Responses',
    responder: 'Answer',
    copiarEnlaceParaCompartirParaResponder: 'Copy the link to share so others can respond with already entered values',
    personaAResponder: 'Person to respond',
    valorIngresado: 'Entered value',
    graficos: 'Charts',
    respuestas: 'Answers',
    respuestaDe: 'Answer from',
    respondedor: 'Responder',
    permisosRespondedor: 'Can Respond and Complete a Form',
    galeriaDeFotos: 'Photo Gallery',
    nro: 'No.',
    departamento: 'Apartment',
    piso: 'Floor',
    exportarResultados: 'Export Results',
    conEnvioDeEmail: 'With email sending',
    quienesLesApareceParaResponder: 'People can respond to',
    conEdicionDeCompletado: 'With completion editing',
    conVisualizacionRestringida: 'With restricted view',
    mostrarDatosInternos: 'Show Internal Data',
    añadirNuevaGaleria: 'Add New Gallery',
    de: 'of',
    laspropias: "Own responses",
    queRespuestasPuedenEditar: "Which responses can be edited",
    archivosSubidos: "Uploaded Files",
    provincia: 'Province',
    asignarSiguienteEstado: 'Assign Next State',
    Rechazado: 'Rejected',
    Aprobado: 'Approved',
    Pendiente: 'Pending',
    autorizar: 'Authorize',
    conAutorizaciones: 'With Authorizations',
    autorizaciones: 'Authorizations',
    ocultarHistorialAutorizaciones: 'Hide Authorization History',
    aQuienesAutorizan: 'Who They Authorize',
    historialDeEstadosDeAutorizacion: 'Authorization State History',
    Finalizado: 'Finalized',
    agregarPor: 'Add by',
    personaEspecifica: 'Specific Person',
    grupo: 'Group',
    estados: 'States',
    autorizador: 'Authorizer',
    autorizarDesordenado: 'Authorize in disorder',
    enviarEmailCambioEstado: 'Send Email on Status Change',
    añadirNuevoMenu: 'Add New Menu',
    menu: 'Menu',
    archivo: 'File',
    enviarEmailAAutorizadores: 'Send email to authorizers',
    enviarEmailResumenDiario: 'Send daily summary email',
    sePuedenAutoAutorizar: 'They can self-authorize',
    noAprobarAutomaticamente: 'Do not approve automatically',
    nombreGrupo: 'Group Name',
    grupos: 'Groups',
    opciones: 'Options',
    opcion: 'Option',
    nombreLista: 'Option List',
    personasRelacionadas: 'Related People',
    responsable: 'Person in charge',
    agregarLista: 'Add List',
    creador: 'Creator',
    nuevoFormulario: 'New Form',
    hola: 'Hello',
    cumpleaños: 'Birthdays',
    guiaDeInternos: 'Staff Directory',
    resAcademicos: 'Academic Results',
    formulariosDescr: 'Internal use requirements',
    menuDescr: 'Lunches of the month',
    guiaDeInternosDescr: 'Office phone numbers',
    goetheDoksDescr: 'Knowledge base',
    resAcademicosDescr: 'Student evaluations',
    calendario: 'Calendar',
    hoy: 'Today',
    Lunes: 'Monday',
    Martes: 'Tuesday',
    Miercoles: 'Wednesday',
    Jueves: 'Thursday',
    Viernes: 'Friday',
    Sábado: 'Saturday',
    Sabado: 'Saturday',
    Domingo: 'Sunday',
    Mañana: 'Tomorrow',
    verTodosLosMenus: 'See all Menus',
    inicio: 'Home',
    verCalendario: 'View Calendar',
    noCumplesHoy: 'No birthdays found for today',
    noCumplesSemana: 'No birthdays found for the week',
    años: 'Years old',
    minimoAutorizacion: 'Minimum authorization',
    darAccesoAlCompletar: 'Grant access upon completion',
    tipoDeAccesoADar: 'Type of access to grant',
    reiniciarPorDefecto: 'Reset to default',
    personalizarColor: 'Customize color',
    elegiTuColorAccent: 'Choose your accent color',
    digitalizacion: 'Digitization',
    digitalizacionDescr: 'Resource center and digital applications',
    secretaria: 'Secretary',
    primaria: 'Primary School',
    secundaria: 'Secondary School',
    galeriaDeFotosDescr: "Institutional Photo Gallery",
    gruposConAcceso: "Groups with access",
    noHayForms: "It looks like you don’t have any shared forms",
    buscarLista: "Search for a group list",
    cargo: 'Position',
    noDocsDisponibles: 'No documents available',
    seguroEliminarDoc: 'Are you sure you want to delete this document?',
    seguroEliminarDocMasivo: 'Are you sure you want to delete these documents in bulk?',
    verDocumento: 'View Document',
    leido: 'Read',
    documento: 'Document',
    fechaCreacion: 'Creation Date',
    fecha: 'Date',
    fechaDocumento: 'Document Date',
    cerrar: 'Close',
    cargandoDocs: 'Loading documents',
    subirDocumentos: 'Upload documents',
    urlCarpeta: 'Folder URL',
    Boletines: 'Report Cards',
    Informes: 'Reports',
    Facturas: 'Invoices',
    tipoDocumento: 'Document type',
    tituloDocumento: 'Document title',
    subirDocsGoetheApp: 'Upload documents to GoetheApp',
    buscarUsuariosFidu: 'Search Fidu users',
    pegaLinkDrive: 'Paste the Drive folder link',
    subidasFidu: 'Uploads to GoetheApp',
    "Con errores": 'With errors',
    Completado: 'Completed',
    Error: 'Error',
    usuariosConectados: 'Connected Users',
    agregarSubgaleria: 'Add Subgallery',
    urlRedireccion: 'Redirection URL',
    imagenPortada: 'Cover Image',
    nuevaGaleria: 'New Gallery',
    galeriaHabilitada: 'Gallery Enabled',
    subGaleriaHabilitada: 'SubGallery Enabled',
    buscarGalerias: 'Search Galleries',
    datosPersonales: 'Personal Data',
    rolesYPermisos: 'Roles & Permissions',
    gruposYListas: 'Groups & Lists',
    volverAPersonas: 'Back to People',
    asignaturas: 'Subjects',
    permisosAsignadosEnUnRol: 'Permissions Already Assigned in a Role',
    permisosAsignables: 'Assignable Permissions',
    ayuda: 'Help',
    noEstaEnNingunaLista: 'Not in any list',
    duplicar: 'Duplicate',
    misRespuestas: 'My Answers',
    noTenesRespuestas: 'You have no answers',
    legajo: 'Employee ID',
    filtros: 'Filters',
    nivel: 'Level', // Educational level
    subido: 'Uploaded',
    general: 'General',
    instructivo: 'Guide',
    configuracion: 'Settings',
    descripcionAnonimo: "If active, responses become anonymous. The completer's identity is not saved. Note that if the form was completed before anonymization, the data of what was already completed remains; it is only visually hidden. For new requirements, the completer is not saved.",
    descripcionAccesoRestringido: 'If active, only users with completer access are allowed to fill out the form.',
    descripcionEdicionCompletado: 'If active, users are allowed to edit responses. You can choose who is allowed to edit.',
    descripcionVisualizacionRestringida: "If active, it limits the responses that can be viewed on the form's visualization page, whether you are a Reader, Editor, or Creator.",
    descripcionAutorizaciones: 'If active, it enables authorizations for requirements.',
    descripcionDarAccesoAlCompletar: 'If active and a user without form access completes it, completer access is automatically added. This allows users to see the form in their My Forms section. Important: access to complete must not be restricted.',
    descripcionConRespuesta: 'If active, it allows readers to respond to requirements. Depending on what is selected, they can respond to certain people.',
    descripcionAutorizarDesordenado: 'This allows authorization steps to be done out of order',
    descripcionOcultarHistorialAutorizaciones: 'Hides the authorization history when authorizing',
    pasosDeAutorizacion: 'Authorization Steps',
    agregarPaso: 'Add Step',
    paso: 'Step',
    faltanAutorizacionesPrevias: 'Prior authorizations are missing',
    habilitar: 'Enable',
    habilitado: 'Enabled',
    deshabilitar: 'Disable',
    deshabilitado: 'Disabled',
    instructivos: 'Guides',
    buscarInstructivos: 'Search Guides',
    codigoEmbebido: 'Embedded Code',
    fechaIngreso: 'Entry Date',
    formPublico: 'Public Form',
    descripcionFormPublico: 'If active, this shows the Form to all users in the My Forms menu',
    autorizadorGeneralDescr: 'If it has the rainbow border, it means the authorizer can authorize in other Steps/Levels ONLY by right-clicking.',
    esProfesor: 'Is Professor',
    empleado: 'Employee',
    externo: 'External',
    filtrar: 'Filter',
    limpiarFiltros: 'Clear filters',
    exportarDatos: 'Export Data',
    parent: 'Parent',
    student: 'Student',
    teacher: 'Teacher',
    executive: 'Executive',
    preceptor: 'Preceptor',
    admin: 'Administrator',
    boletinNoticias: 'Newsletter',
    nuevoInstructivo: 'New Guide',
    carpeta: 'Folder',
    noEncontramosInstructivo: 'It seems we couldn\'t find the guide you were looking for',
    noEncontramosForm: 'It seems we couldn\'t find the form you were looking for',
    errorConElServidor: 'Cannot connect to the server, please try again in a few minutes',
    galeria: 'Gallery',
    esPublicoATodos: 'Is public for everyone',
    esPublicaATodos: 'Is public for everyone',
    permisosLectorInstructivo: 'Can view guides',
    permisosEditorInstructivo: 'Can view, edit and give access to guides',
    permisosLectorGaleria: 'Can view galleries',
    permisosEditorGaleria: 'Can view, edit and give access to galleries',
    noEncontramosGaleria: 'It seems we couldn\'t find the gallery you were looking for',
    logoEmbebido: 'Embedded logo',
    reporte: 'Report',
    error: 'Error',
    subir: 'Upload',
    gestionTokens: 'Token management',
    activo: 'Active',
    revocado: 'Revoked',
    expirado: 'Expired',
    expira: 'Expires',
    creado: 'Created',
    noSeEncontraronTokens: 'No tokens found',
    pagina: 'Page',
    confirmarRevocarToken: "Are you sure you want to revoke the Token?",
    antiguo: "Old",
    clickAcaParaCompletarForm: 'Click here to complete the form',
    infoPersonal: 'Personal Information',
    pasaporte: 'Passport',
    infoDeContacto: 'Contact Information',
    origenYNacionalidad: 'Origin and Nationality',
    infoInstitucional: 'Institutional Information',
    direcciones: 'Addresses',
    localidadDeNacimiento: 'Place of Birth',
    dni: 'ID Card',
    guardarCambios: 'Save changes',
    actualizarEn: 'Update in',
    'N/A': 'N/A',
    desconocido: 'Unknown',
    Enconcubinato: 'Cohabitation',
    'Separado(a)': 'Separated',
    fechaFallecimiento: 'Date of Death',
    ultimaActualizacion: 'Last Update',
    listas: 'Lists',
    sinListas: 'Without Lists',
    y: '&',
    historialRoles: 'Role History',
    asignarRol: 'Assign Role',
    motivo: 'Reason',
    adminTreffpunkt: 'Treffpunkt Admin',
    direccion: 'Address',
    particular: 'Home',
    laboral: 'Work',
    otro: 'Other',
    principal: 'Main',
    direccionCompartidaCon: 'Address shared with',
    direccionSeLeActualizaraTambienA: 'The address will also be updated for',
    calle: 'Street',
    paisRequerido: 'Country required',
    provinciaRequerida: 'Province is required',
    localidadRequerida: 'City/Town is required',
    calleRequerida: 'Street is required',
    nroRequerido: 'Number is required',
    codigoPostalRequerido: 'Postal code is required',
    seleccionarProvincia: 'Select province',
    subirA: 'Upload to',
    fechaNacimientoRequerida: 'Date of birth required',
    celularRequerido: 'Cell phone required',
    estadoCivilRequerido: 'Marital status required',
    generoRequerido: 'Gender required',
    emailRequerido: 'Email required',
    agregarNivelSector: 'Add Level/Sector',
    nivelSectorRequerido: 'Level/Sector required',
    nacionalidadRequerida: 'Nationality required',
    nombreRequerido: 'Name required',
    telefonoRequerido: 'Phone required',
    relacionRequerida: 'Relationship required',
    admintreffpunkt: 'Admin Treffpunkt',
    preferencias: 'Preferences',
    esconderCumple: 'Hide my birthday',
    emailDe: 'Email from',
    Responsable: 'Responsible Party',
    alMenosUnaDireccionPrincipal: 'At least one address must be a primary address',
    idsInternosYExternos: 'Internal and External IDs',
    tipoPersona: 'Type of Person',
    nroDni: 'ID No.',
    siglaUntis: 'UNTIS Acronym',
    perfilEn: 'Profile on',
    "comision directiva": 'Board of Directors',
    rolOculto: 'Hidden role',
    cicloLectivo: 'Academic Year',
    ninguno: 'None',
    tipoDocente: 'Type of teacher',
    jardin: 'Kindergarten',
    administracion: 'Administration',
    mantenimiento: 'Maintenance',
    jerarquicos: 'Hierarchical',
    Exportadores: 'Exporters',
    cargandoHorarios: 'Loading schedules...',
    horarios: 'Schedules',
    horario: 'Schedule',
    noSeEncontrarioHorarios: 'No schedules found.',
    jerárquico: 'Hierarchical',
    agds: 'AGDS',
    comisionDirectiva: 'Board of Directors',
    horarioFijo: 'Fixed Schedule',
    turno: 'Shift',
    homeOffice: 'Home Office',
    presencial: 'In-person',
    rrhh: 'HR',
    noResultados: 'No results found',
    fichadas: 'Clocked in',
    reloj: 'Clock',
    semanaActual: 'Current week',
    vacaciones: 'Vacations',
    horarioDeReceso: 'Recess Schedule',
    licenciaEspecial: 'Special License',
    diaExamen: 'Exam Day',
    diaEstudio: 'Study Day',
    embarazo: 'Pregnancy',
    adlk: 'ADLK',
    bplk: 'BPLK',
    dolk: 'DOLK',
    olk: 'OLK',
    diaNoLaborable: 'Non-working day',
    asignarDiaNoLaborablePorSectores: 'Assign non-working day by sectors',
    noHaySectoresDisponibles: 'No sectors available',
    sectoresAfectados: 'Affected sectors',
    asignarRecesoPorSectores: 'Assign recess by sectors',
    nuevoHorarioDeReceso: 'New recess schedule',
    noSeEncontraronEmpleados: 'No employees found',
    'Ausente / Sin fichadas': 'Absent / No clock-ins',
    'Vacaciones': 'Vacations',
    'Fichadas incompletas': 'Incomplete clock-ins',
    'Cumplió horario': 'Met schedule',
    'Horas extra': 'Overtime',
    'Feriado': 'Holiday',
    'Cumplió las horas': 'Met hours',
    'Llegó tarde': 'Arrived late',
    'Se retiró antes': 'Left early',
    'Llegó tarde y se retiró antes': 'Arrived late and left early',
    enfermedad:'Sickness',
    deporte: 'Sports',
    horaDesde: 'Time from',
    horaHasta: 'Time until',
    periodoDesde: 'Period from',
    periodoHasta: 'Period until',
    sector: 'Sector',
    practicante: 'Intern',
    pasante: 'Trainee',
    verCarpeta: 'View Folder',
    verLogs: 'View Logs',
    al: 'to',
    niHorariosNiFichadas: 'No fixed schedules or clock-ins',
    errorPeriodoMaximo31Dias: 'The maximum allowed period is 31 days',
    errorDesdeNoMayorHasta: "'From' date cannot be greater than 'Until' date",
    buscarEmpleadoPorNombreLegajo: 'Search employee by name or ID',
    periodoHastaOpcional: 'Period until (Optional)',
    diaDeLaSemana: 'Day of the week',
    esHomeOffice: 'Is Home Office',
    todosLosDiasHabiles: 'All business days',
    nuevo: 'New',
    tipoLicencia: 'Type of license',
    esconderEdadCumple: 'Hide my age on my birthday',
    edad: 'Age',
    nroInterno: 'Internal No.',
    email: 'Email',
    enero: 'January',
    febrero: 'February',
    marzo: 'March',
    abril: 'April',
    mayo: 'May',
    junio: 'June',
    julio: 'July',
    agosto: 'August',
    septiembre: 'September',
    octubre: 'October',
    noviembre: 'November',
    diciembre: 'December',
    delAlumno: 'of the student',
    completado: 'Completed',
    alerta: 'Alert',
    eliminado: 'Deleted',
    pendiente: 'Pending',
    usuarios: 'Users',
    subidas: 'Uploads',
    cancelado: 'Canceled',
    cancelarSubida: 'Cancel upload',
    mias: 'Mine',
    todas: 'All',
    reservaEspacios: 'Space reservation',
    inventario: 'Inventory',
    buscarDocentePorNombre: 'Search teacher by name',
    seleccionarFechaSemana: 'Select date/week',
    horarioDocente: 'Teacher schedule',
    ausencias: 'Absences',
    horas: 'Hours',
    justificada: 'Justified',
    injustificada: 'Unjustified',
    sinAusenciasPeriodo: 'No absences in the selected period',
    clasesSimultaneas: 'Simultaneous classes',
    sinCertificado: 'Without certificate',
    verCertificado: 'View certificate',
    eliminarArchivosViejos: 'Delete old files',
    eliminarArchivosViejosConfirmacion: 'Are you sure you want to delete all files older than 1 month?',
    noSePodraVolverAtras: 'This action cannot be undone and the files will be permanently lost.',
    almacenamientoTreffpunkt: 'Storage in Treffpunkt',
    cargando: 'Loading',
    clases: 'Classes',
    aula: 'Classroom',
    reemplazaA: 'Replaces',
    hora: 'Time',
    suplencias: 'Substitutions',
    suplencia: 'Substitution',
    ausente: 'Absent',
    sinSuplenciasPeriodo: 'No substitutions in the selected period',
    seleccionarPeriodoExportar: 'Select the fortnight period you want to export for the sector',
    exportarLicAusViaExtrAExcel: 'Export licenses, absences, trips, and overtime to Excel',
    exportarExcel: 'Export to Excel',
    generando: 'Generating',
    descargar: 'Download',
    periodo: 'Period',
    mapasAprendizaje: "Learning Maps",
    instructivoHorariosBackOffice: 'Guide for Back Office schedules',
    documentacion: 'Documentation',
    permiso: 'Permission',
    categoria: 'Category',
    subCategoria: 'Subcategory',
    seleccionePersona: 'Select a person',
    asignarNuevaPersona: 'Assign a new person to this permission',
    asignar: 'Assign',
    asignadoEl: 'Assigned to',
    sinPersonasAsignadas: 'No people have been assigned this permission directly.',
    confirmarQuitarPersona: 'Are you sure you want to remove this permission from this person?',
    nombrePermiso: 'Permission Name',
    personasAsignadasPorRol: 'Assigned People by Role',
    personasAsignadasPorPermiso: 'Assigned People by Permission',
    usuariosSinHorarioOFichadasNoApareceran: 'Users without assigned schedule within the last 30 days will not appear.',
    recruiting: 'Recruiting',
  },

  de: {
    welcome: 'Willkommen bei TreffPunkt!',
    formularios: 'Formulare',
    listaFormularios: 'Formularliste',
    titulo: 'Titel',
    creadoPor: 'Erstellt von',
    creacion: 'Erstellung',
    ultMod: 'Lzt. Änd.',
    buscarFormularios: 'Formulare suchen',
    observacion: 'Beobachtung',
    tipo: 'Typ',
    completar: 'Ausfüllen',
    editar: 'Bearbeiten',
    darAcceso: 'Zugang gewähren',
    eliminar: 'Löschen',
    compartir: 'Teilen',
    evaluado: 'Bewertet',
    materia: 'Fach',
    observaciones: 'Beobachtungen',
    comentario: 'Kommentar',
    caracteres: 'Zeichen',
    enviar: 'Senden',
    cancelar: 'Abbrechen',
    crearNuevoFormulario: 'Neues Formular erstellen',
    nombreFormulario: 'Formularname',
    descripcion: 'Beschreibung',
    accesoRestringido: 'Eingeschränkter Zugang',
    agregarEvaluado: 'Bewerteten hinzufügen',
    agregarEleccionMateria: 'Fachwahl hinzufügen',
    agregarObservacion: 'Beobachtung hinzufügen',
    guardar: 'Speichern',
    seleccionarTipoATraer: '(Typ auswählen)',
    ingreseTituloObservacion: 'Geben Sie den Titel der Beobachtung ein',
    CondicionObservada: 'Beobachteter Zustand',
    Fecha: 'Datum',
    Hora: 'Uhrzeit',
    Opciones: 'Optionen',
    Rango: 'Bereich',
    TextoCorto: 'Kurztext',
    agregarComentario: 'Kommentar hinzufügen',
    obligatorio: 'Verpflichtend',
    profesor: 'Lehrer',
    familiar: 'Familienmitglied',
    alumno: 'Schüler',
    agregar: 'Hinzufügen',
    agregarItem: 'Element hinzufügen',
    copiar: 'Kopieren',
    copiarEnlaceParaCompartir: 'Link zum Teilen kopieren',
    lector: 'Leser',
    editor: 'Bearbeiter',
    completador: 'Ausfüller',
    agregarPersonas: 'Personen hinzufügen',
    permisosLector: 'Kann das Formular ausfüllen und die Ergebnisse ansehen',
    permisosEditor: 'Kann das Formular ausfüllen, antworten, bearbeiten, Zugang gewähren und löschen',
    permisosCompletador: 'Kann das Formular mit Daten ausfüllen',
    personasConAcceso: 'Personen mit Zugang',
    cerrarSesion: 'Abmelden',
    permisos: 'Berechtigungen',
    volver: 'Zurück',
    buscarPersona: 'Person suchen',
    seleccionaFecha: 'Wählen Sie ein Datum',
    seleccionaHora: 'Wählen Sie eine Uhrzeit',
    formEnviadoExitosamente: 'Formular erfolgreich gesendet',
    seleccionarValorRango: 'Sie müssen einen Bereichswert für die Beobachtung auswählen',
    editarFormulario: 'Formular bearbeiten',
    por: 'von',
    subirArchivo: 'Datei hochladen',
    tamanoMaximo: 'Maximale Größe',
    archivoSeleccionado: 'Ausgewählte Datei',
    Archivo: 'Datei',
    cursoGrupo: 'Kurs oder Gruppe',
    buscar:'Suchen',
    Evaluado: 'Bewertet',
    personalizado: 'Personalisiert',
    agregarPersona: 'Person hinzufügen',
    loginGoogle: 'Melden Sie sich mit Google an',
    porfavorLogin: 'Bitte melden Sie sich an',
    personasSeleccionadas: 'Ausgewählte Personnen',
    anterior: 'Vorherige',
    siguiente: 'Nächste',
    confirmar: 'Bestätigen',
    seguroEliminarForm: 'Sind Sie sicher, dass Sie dieses Formular löschen möchten',
    Si: 'Ja',
    No: 'Nein',
    "No Observable": 'Nicht Beobachtbar',
    min: 'Min',
    max: 'Max',
    step: 'Schritt',
    todosLosFormularios: 'Alle Formulare anzeigen',
    personas: 'Personen',
    beneficios: 'Mitarbeitervorteile',
    misDatos: 'Meine Daten',
    apellido: 'Nachname',
    nombre: 'Vorname',
    emails: 'E-Mails',
    dniPasaporte: 'DNI/Reisepass',
    estadoCivil: 'Familienstand',
    genero: 'Geschlecht',
    masculino: 'Männlich',
    femenino: 'Weiblich',
    noBinario: 'Nicht-binär',
    prefieroNoDecirlo: 'Bevorzuge es nicht zu sagen',
    fechaNacimiento: 'Geburtsdatum',
    paisDeNacimiento: 'Geburtsland',
    nacionalidades: 'Nationalitäten',
    lenguasMaternas: 'Muttersprache',
    domicilio: 'Adresse',
    localidad: 'Ort',
    codigoPostal: 'Postleitzahl',
    barrio: 'Stadtteil',
    contacto: 'Kontakt',
    celular: 'Handy',
    telefonoFijo: 'Festnetz',
    contactoDeEmergencia: 'Notfallkontakt',
    telefonoCelular: 'Telefon/Handy',
    provinciaDeNacimiento: 'Geburtsprovinz',
    agregarEmail: 'Weiteren E-Mail hinzufügen',
    agregarNacionalidad: 'Nationalität hinzufügen',
    agregarLenguaMaterna: 'Muttersprache hinzufügen',
    emailProfesional: 'Berufliche E-Mail',
    emailsPersonales: 'Persönliche E-Mail-Adresse (Registrierte elektronische Adresse)',
    vinculoRelacion: 'Beziehung/Verbindung',
    abuelo: 'Großvater/Großmutter',
    amigo: 'Freund/Freundin',
    cuidador: 'Betreuer/Betreuerin',
    hijo: 'Sohn-Tochter',
    nieto: 'Enkel/Enkelin',
    padreMadre: 'Vater/Mutter',
    pareja: 'Partner/Partnerin',
    primo: 'Cousin/Cousine',
    sobrino: 'Neffe/Nichte',
    socio: 'Partner',
    tio: 'Onkel/Tante',
    tutor: 'Tutor/Tutorin',
    vecino: 'Nachbar/Nachbarin',
    nivelSector: 'Level/Sektor',
    verPerfil: 'Profil anzeigen',
    datosInternos: 'Interne Daten',
    estado: 'Status',
    roles: 'Rollen',
    Retirado: 'Abgezogen',
    Activo: 'Aktiv',
    Egresado: 'Absolviert',
    Inactivo: 'Inaktiv',
    "Soltero(a)": 'Ledig',
    "Casado(a)": "Verheiratet",
    "Divorciado(a)": "Geschieden",
    "Viudo(a)": "Witwe/Witwer",
    datosPersona: 'Personen Daten',
    buscarPersonas: 'Personen suchen',
    buscarPorNombre: 'Nach Name suchen',
    searchValuesPersonas: "Sie können suchen nach: Nachname, Vorname und E-Mail",
    conAccesoRestringido: "Eingeschränktem Zugang",
    anonimo: 'Anonym',  
    formAnonimo: 'Dieses Formular ist anonym.',
    rol: "Rolle",
    agregarPermisos: "Berechtigungen hinzufügen",
    accesos: 'Zugriffe',
    jefe: 'Chef',
    buscarRoles: 'Rollen suchen',
    nombreRol: 'Rollenname',
    agregarRol: 'Rolle hinzufügen',
    agregarPermiso: 'Berechtigung hinzufügen',
    sinPermisos: 'Keine Berechtigungen',
    personasQuePuedenVerLaObservacion: 'Personen, die die Beobachtung sehen können',
    obsOculta: 'Versteckte Beobachtung',
    obsObligatoria: 'Obligatorische Beobachtung',
    subordinados: 'Untergebene',
    todos: 'Alle',
    conRespuesta: 'Mit Antworten',
    responder: 'Antworten',
    copiarEnlaceParaCompartirParaResponder: 'Kopieren Sie den Link, um ihn zu teilen, damit andere bereits eingegebene Werte beantworten können',
    personaAResponder: 'Person, die antworten soll',
    valorIngresado: 'Eingegebener Wert',
    graficos: 'Diagramme',
    respuestas: 'Antworten',
    respuestaDe: 'Antwort von',
    respondedor: 'Antwortgeber',
    permisosRespondedor: 'Kann ein Formular beantworten und ausfüllen',
    galeriaDeFotos: 'Fotogalerie',
    nro: 'Nr.',
    departamento: 'Wohnung',
    piso: 'Stockwerk',
    exportarResultados: 'Ergebnisse exportieren',
    conEnvioDeEmail: 'Mit E-Mail-Versand',
    quienesLesApareceParaResponder: 'Personen können antworten auf',
    conEdicionDeCompletado: 'Mit Fertigstellung Bearbeitung',
    conVisualizacionRestringida: 'Mit eingeschränkter Ansicht',
    mostrarDatosInternos: 'Interne Daten anzeigen',
    añadirNuevaGaleria: 'Neue Galerie hinzufügen',
    de: 'von',
    laspropias: "Eigene Antworten",
    queRespuestasPuedenEditar: "Welche Antworten können bearbeitet werden",
    archivosSubidos: "Hochgeladene Dateien",
    provincia: 'Provinz',
    asignarSiguienteEstado: 'Nächsten Status zuweisen',
    Rechazado: 'Abgelehnt',
    Aprobado: 'Genehmigt',
    Pendiente: 'Ausstehend',
    autorizar: 'Autorisieren',
    conAutorizaciones: 'Mit Autorisierungen',
    autorizaciones: 'Autorisierungen',
    ocultarHistorialAutorizaciones: 'Autorisierungsverlauf ausblenden',
    aQuienesAutorizan: 'Wen sie autorisieren',
    historialDeEstadosDeAutorizacion: 'Verlauf der Autorisierungszustände',
    Finalizado: 'Finalisiert',
    agregarPor: 'Hinzufügen nach',
    personaEspecifica: 'Spezifische Person',
    grupo: 'Gruppe',
    estados: 'Status',
    autorizador: 'Genehmiger',
    autorizarDesordenado: 'Ungeordnete Genehmigung',
    enviarEmailCambioEstado: 'E-Mail bei Statusänderung senden',
    añadirNuevoMenu: 'Neues Menü hinzufügen',
    menu: 'Menü',
    archivo: 'Datei',
    enviarEmailAAutorizadores: 'E-Mail an Autorisierende senden',
    enviarEmailResumenDiario: 'Tägliche Zusammenfassungs-E-Mail senden',
    sePuedenAutoAutorizar: 'Dürfen sich selbst autorisieren',
    noAprobarAutomaticamente: 'Nicht automatisch genehmigen',
    nombreGrupo: 'Gruppenname',
    grupos: 'Gruppen',
    opciones: 'Optionen',
    opcion: 'Option',
    nombreLista: 'Listename',
    personasRelacionadas: 'Zugehörige Personen',
    responsable: 'Zuständige Person',
    agregarLista: 'Liste hinzufügen',
    creador: 'Ersteller',
    nuevoFormulario: 'Neue Formular',
    hola: 'Hallo',
    cumpleaños: 'Geburtstage',
    guiaDeInternos: 'Mitarbeiterverzeichnis',
    resAcademicos: 'Schulische Leistungen',
    formulariosDescr: 'Interne Aufträge',
    menuDescr: 'Mittagsessen des Monat',
    guiaDeInternosDescr: 'Telefonnummern der Büros',
    goetheDoksDescr: 'Wissensdatenbank',
    resAcademicosDescr: 'Ergebnisse der Prüfungen',
    calendario: 'Kalender',
    hoy: 'Heute',
    Lunes: 'Montag',
    Martes: 'Dienstag',
    Miercoles: 'Mittwoch',
    Jueves: 'Donnerstag',
    Viernes: 'Freitag',
    Sabado: 'Samstag',
    Sábado: 'Samstag',
    Domingo: 'Sonntag',
    Mañana: 'Morgen',
    verTodosLosMenus: 'Alle Menüs anzeigen',
    inicio: 'Startseite',
    verCalendario: 'Kalender anzeigen',
    noCumplesHoy: 'Heute wurden keine Geburtstage gefunden',
    noCumplesSemana: 'Für diese Woche wurden keine Geburtstage gefunden',
    años: 'Jahre alt',
    minimoAutorizacion: 'Mindestberechtigung',
    darAccesoAlCompletar: 'Zugriff nach dem Ausfüllen gewähren',
    tipoDeAccesoADar: 'Zugriffsart gewähren',
    reiniciarPorDefecto: 'Auf Standard zurücksetzen',
    personalizarColor: 'Farbe anpassen',
    elegiTuColorAccent: 'Wähle deine Akzentfarbe',
    digitalizacion: 'Digitalisierung',
    digitalizacionDescr: 'Ressourcenzentrum und digitale Anwendungen',
    secretaria: 'Sekretariat',
    primaria: 'Grundschule',
    secundaria: 'Sekundarschule',
    galeriaDeFotosDescr: "Institutionelle Fotogalerie",
    gruposConAcceso: "Gruppen mit Zugriff",
    noHayForms: "Du hast anscheinend keine geteilten Formulare",
    buscarLista: "Gruppenliste suchen",
    cargo: 'Position',
    noDocsDisponibles: 'Keine Dokumente verfügbar',
    seguroEliminarDoc: 'Möchten Sie dieses Dokument wirklich löschen?',
    seguroEliminarDocMasivo: 'Möchten Sie diese Dokumente wirklich massenhaft löschen?',
    verDocumento: 'Dokument ansehen',
    leido: 'Gelesen',
    documento: 'Dokument',
    fechaCreacion: 'Erstellungsdatum',
    fecha: 'Datum',
    fechaDocumento: 'Dokumentdatum',
    cerrar: 'Schließen',
    cargandoDocs: 'Dokumente werden geladen',
    subirDocumentos: 'Dokumente hochladen',
    urlCarpeta: 'Ordner-URL',
    Boletines: 'Zeugnisse',
    Informes: 'Berichte',
    Facturas: 'Rechnungen',
    tipoDocumento: 'Dokumenttyp',
    tituloDocumento: 'Dokumenttitel',
    subirDocsGoetheApp: 'Dokumente in GoetheApp hochladen',
    buscarUsuariosFidu: 'Fidu-Benutzer suchen',
    pegaLinkDrive: 'Link zum Drive-Ordner einfügen',
    subidasFidu: 'Uploads zu GoetheApp',
    "Con errores": 'Mit Fehlern',
    Completado: 'Abgeschlossen',
    Error: 'Fehler',
    usuariosConectados: 'Verbundene Benutzer',
    agregarSubgaleria: 'Untergalerie hinzufügen',
    urlRedireccion: 'Weiterleitungs-URL',
    imagenPortada: 'Titelbild',
    nuevaGaleria: 'Neue Galerie',
    galeriaHabilitada: 'Galerie aktiviert',
    subGaleriaHabilitada: 'Untergalerie aktiviert',
    buscarGalerias: 'Galerien suchen',
    datosPersonales: 'Persönliche Daten',
    rolesYPermisos: 'Rollen und Berechtigungen',
    gruposYListas: 'Gruppen und Listen',
    volverAPersonas: 'Zurück zu Personen',
    asignaturas: 'Fächer',
    permisosAsignadosEnUnRol: 'Berechtigungen bereits in einer Rolle zugewiesen',
    permisosAsignables: 'Zuweisbare Berechtigungen',
    ayuda: 'Hilfe',
    noEstaEnNingunaLista: 'Nicht in keiner Liste',
    duplicar: 'Verdoppeln',
    misRespuestas: 'Meine Antworten',
    noTenesRespuestas: 'Sie hast keine Antworten',
    legajo: 'Mitarbeiternummer',
    filtros: 'Filter',
    nivel: 'Niveau', // Bildungsniveau
    subido: 'Hochgeladen',
    general: 'Allgemein',
    instructivo: 'Instruktiv',
    configuracion: 'Einstellungen',
    descripcionAnonimo: 'Wenn aktiv, werden die Antworten anonymisiert. Die Identität des Ausfüllenden wird nicht gespeichert. Beachten Sie, dass, wenn das Formular vor der Anonymisierung ausgefüllt wurde, die Daten des bereits Ausgefüllten erhalten bleiben; sie werden nur visuell ausgeblendet. Für neue Anforderungen wird der Ausfüllende nicht gespeichert.',
    descripcionAccesoRestringido: 'Wenn aktiv, dürfen nur Benutzer mit Ausfüllerzugriff das Formular ausfüllen.',
    descripcionEdicionCompletado: 'Wenn aktiv, dürfen Benutzer Antworten bearbeiten. Es kann ausgewählt werden, wer bearbeiten darf.',
    descripcionVisualizacionRestringida: 'Wenn aktiv, werden die Antworten, die auf der Visualisierungsseite des Formulars angezeigt werden können, eingeschränkt, unabhängig davon, ob Sie ein Leser, Bearbeiter oder Ersteller sind.',
    descripcionAutorizaciones: 'Wenn aktiv, werden Genehmigungen für Anforderungen aktiviert.',
    descripcionDarAccesoAlCompletar: 'Wenn aktiv und ein Benutzer ohne Formularzugriff das Formular ausfüllt, wird automatisch der Ausfüllerzugriff hinzugefügt. Dadurch können Benutzer das Formular in ihrem Bereich "Meine Formulare" sehen. Wichtig: Der Zugriff zum Ausfüllen darf nicht eingeschränkt sein.',
    descripcionConRespuesta: 'Wenn aktiv, erlaubt es Lesern, auf Anforderungen zu antworten. Je nachdem, was ausgewählt ist, können sie bestimmten Personen antworten.',
    descripcionAutorizarDesordenado: 'Dies ermöglicht, dass die Genehmigungsschritte in beliebiger Reihenfolge durchgeführt werden können',
    descripcionOcultarHistorialAutorizaciones: 'Verbirgt den Genehmigungsverlauf bei der Genehmigung',
    pasosDeAutorizacion: 'Genehmigungsschritte',
    agregarPaso: 'Schritt hinzufügen',
    paso: 'Schritt',
    faltanAutorizacionesPrevias: 'Es fehlen vorherige Genehmigungen',
    habilitar: 'Aktivieren',
    habilitado: 'Aktiviert',
    deshabilitar: 'Deaktivieren',
    deshabilitado: 'Deaktiviert',
    instructivos: 'Anleitungen',
    buscarInstructivos: 'Anleitungen suchen',
    codigoEmbebido: 'Eingebetteter Code',
    fechaIngreso: 'Eingangsdatum',
    formPublico: 'Öffentliches Formular',
    descripcionFormPublico: 'Wenn aktiv, wird das Formular allen Benutzern im Menü "Meine Formulare" angezeigt',
    autorizadorGeneralDescr: 'Wenn es den Regenbogenrand hat, bedeutet dies, dass der Genehmiger in anderen Schritten/Ebenen NUR durch Rechtsklicken genehmigen kann.',
    esProfesor: 'Ist Professor',
    empleado: 'Mitarbeiter',
    externo: 'Extern',
    filtrar: 'Filtern',
    limpiarFiltros: 'Filter löschen',
    exportarDatos: 'Daten exportieren',
    parent: 'Elternteil',
    student: 'Schüler',
    teacher: 'Lehrer',
    executive: 'Direktor',
    preceptor: 'Betreuer',
    admin: 'Administrator',
    boletinNoticias: 'Rundschreiben',
    nuevoInstructivo: 'Neue Anleitung',
    carpeta: 'Ordner',
    noEncontramosInstructivo: 'Wir konnten die gesuchte Anleitung anscheinend nicht finden',
    noEncontramosForm: 'Wir konnten das gesuchte Formular anscheinend nicht finden',
    errorConElServidor: 'Verbindung zum Server nicht möglich. Bitte versuchen Sie es in ein paar Minuten erneut',
    galeria: 'Galerie',
    esPublicoATodos: 'Ist für alle öffentlich',
    esPublicaATodos: 'Ist für alle öffentlich',
    permisosLectorInstructivo: 'Kann Anleitungen ansehen',
    permisosEditorInstructivo: 'Kann Anleitungen ansehen, bearbeiten und Zugriff gewähren',
    permisosLectorGaleria: 'Kann Galerien ansehen',
    permisosEditorGaleria: 'Kann Galerien ansehen, bearbeiten und Zugriff gewähren',
    noEncontramosGaleria: 'Wir konnten die gesuchte Galerie anscheinend nicht finden',
    logoEmbebido: 'Eingebettetes Logo',
    reporte: 'Bericht',
    error: 'Fehler',
    subir: 'Hochladen',
    gestionTokens: 'Token-Verwaltung',
    activo: 'Aktiv',
    revocado: 'Widerrufen',
    expirado: 'Abgelaufen',
    expira: 'Läuft ab',
    creado: 'Erstellt',
    noSeEncontraronTokens: 'Keine Token gefunden',
    pagina: 'Seite',
    confirmarRevocarToken: "Möchten Sie das Token wirklich widerrufen?",
    antiguo: "Alt",
    clickAcaParaCompletarForm: 'Klicken Sie hier, um das Formular auszufüllen',
    infoPersonal: 'Persönliche Informationen',
    pasaporte: 'Reisepass',
    infoDeContacto: 'Kontaktinformationen',
    origenYNacionalidad: 'Herkunft und Staatsangehörigkeit',
    infoInstitucional: 'Institutionelle Informationen',
    direcciones: 'Adressen',
    localidadDeNacimiento: 'Geburtsort',
    dni: 'Personalausweis',
    guardarCambios: 'Änderungen speichern',
    actualizarEn: 'Aktualisieren in',
    'N/A': 'k.A.', // (k.A. es la abreviatura de "keine Angabe")
    desconocido: 'Unbekannt',
    Enconcubinato: 'Konkubinat',
    'Separado(a)': 'Getrennt',
    fechaFallecimiento: 'Todesdatum',
    ultimaActualizacion: 'Letzte Aktualisierung',
    listas: 'Listen',
    sinListas: 'Ohne Listen',
    y: 'und',
    historialRoles: 'Rollenverlauf',
    asignarRol: 'Rolle zuweisen',
    motivo: 'Grund',
    adminTreffpunkt: 'Treffpunkt-Admin',
    direccion: 'Adresse',
    particular: 'Privat',
    laboral: 'Arbeit',
    otro: 'Andere',
    principal: 'Haupt',
    direccionCompartidaCon: 'Adresse geteilt mit',
    direccionSeLeActualizaraTambienA: 'Die Adresse wird ebenfalls aktualisiert für',
    calle: 'Straße',
    paisRequerido: 'Land erforderlich',
    provinciaRequerida: 'Provinz ist erforderlich',
    localidadRequerida: 'Ort ist erforderlich',
    calleRequerida: 'Straße ist erforderlich',
    nroRequerido: 'Nummer ist erforderlich',
    codigoPostalRequerido: 'Postleitzahl ist erforderlich',
    seleccionarProvincia: 'Provinz auswählen',
    subirA: 'Hochladen nach',
    fechaNacimientoRequerida: 'Geburtsdatum erforderlich',
    celularRequerido: 'Handynummer erforderlich',
    estadoCivilRequerido: 'Familienstand erforderlich',
    generoRequerido: 'Geschlecht erforderlich',
    emailRequerido: 'E-Mail erforderlich',
    agregarNivelSector: 'Ebene/Sektor hinzufügen',
    nivelSectorRequerido: 'Ebene/Sektor erforderlich',
    nacionalidadRequerida: 'Staatsangehörigkeit erforderlich',
    nombreRequerido: 'Name erforderlich',
    telefonoRequerido: 'Telefonnummer erforderlich',
    relacionRequerida: 'Beziehung erforderlich',
    admintreffpunkt: 'Admin Treffpunkt',
    preferencias: 'Einstellungen',
    esconderCumple: 'Meinen Geburtstag verbergen',
    emailDe: 'E-Mail von',
    Responsable: 'Verantwortliche Person',
    alMenosUnaDireccionPrincipal: 'Mindestens eine Adresse muss eine Hauptadresse sein',
    idsInternosYExternos: 'Interne und Externe IDs',
    tipoPersona: 'Personentyp',
    nroDni: 'Ausweisnummer',
    siglaUntis: 'UNTIS-Kürzel',
    perfilEn: 'Profile auf',
    "comision directiva": 'Vorstand',
    rolOculto: 'Versteckte Rolle',
    cicloLectivo: 'Schuljahr',
    ninguno: 'Keiner',
    tipoDocente: 'Lehrertyp',
    jardin: 'Kindergarten',
    administracion: 'Verwaltung',
    mantenimiento: 'Wartung',
    jerarquicos: 'Hierarchisch',
    Exportadores: 'Exporteure',
    cargandoHorarios: 'Zeitpläne werden geladen...',
    horarios: 'Zeitpläne',
    horario: 'Zeitplan',
    noSeEncontrarioHorarios: 'Keine Zeitpläne gefunden.',
    jerárquico: 'Hierarchisch',
    agds: 'AGDS',
    comisionDirectiva: 'Vorstand',
    horarioFijo: 'Fester Zeitplan',
    turno: 'Schicht',
    homeOffice: 'Home Office',
    presencial: 'Präsenz',
    rrhh: 'HR',
    noResultados: 'Keine Ergebnisse gefunden',
    fichadas: 'Eingestempelt',
    reloj: 'Uhr',
    semanaActual: 'Aktuelle Woche',
    vacaciones: 'Urlaub',
    horarioDeReceso: 'Pausenzeitplan',
    licenciaEspecial: 'Sonderurlaub',
    diaExamen: 'Prüfungstag',
    diaEstudio: 'Studientag',
    embarazo: 'Schwangerschaft',
    adlk: 'ADLK',
    bplk: 'BPLK',
    dolk: 'DOLK',
    olk: 'OLK',
    diaNoLaborable: 'Nicht-Arbeitstag',
    asignarDiaNoLaborablePorSectores: 'Nicht-Arbeitstag nach Sektoren zuweisen',
    noHaySectoresDisponibles: 'Keine Sektoren verfügbar',
    sectoresAfectados: 'Betroffene Sektoren',
    asignarRecesoPorSectores: 'Pausenzeitplan nach Sektoren zuweisen',
    nuevoHorarioDeReceso: 'Neuer Pausenzeitplan',
    noSeEncontraronEmpleados: 'Keine Mitarbeiter gefunden',
    'Ausente / Sin fichadas': 'Abwesend / Keine Stempelungen',
    'Vacaciones': 'Urlaub',
    'Fichadas incompletas': 'Unvollständige Stempelungen',
    'Cumplió horario': 'Zeitplan eingehalten',
    'Horas extra': 'Überstunden',
    'Feriado': 'Feiertag',
    'Cumplió las horas': 'Stunden erfüllt',
    'Llegó tarde': 'Zu spät gekommen',
    'Se retiró antes': 'Früher gegangen',
    'Llegó tarde y se retiró antes': 'Zu spät gekommen und früher gegangen',
    enfermedad:'Krankheit',
    deporte: 'Sport',
    horaDesde: 'Uhr von',
    horaHasta: 'Uhr bis',
    periodoDesde: 'Periode von',
    periodoHasta: 'Periode bis',
    sector: 'Sektor',
    practicante: 'Praktikant',
    pasante: 'Praktikant',
    verCarpeta: 'Ordner ansehen',
    verLogs: 'Protokolle ansehen',
    al: 'bis',
    niHorariosNiFichadas: 'Keine festen Zeitpläne oder Sektoren',
    errorPeriodoMaximo31Dias: 'Der maximal erlaubte Zeitraum beträgt 31 Tage',
    errorDesdeNoMayorHasta: "'Von'-Datum darf nicht größer sein als 'Bis'-Datum",
    buscarEmpleadoPorNombreLegajo: 'Mitarbeiter nach Name oder ID suchen',
    periodoHastaOpcional: 'Periode bis (Optional)',
    diaDeLaSemana: 'Wochentag',
    esHomeOffice: 'Ist Home Office',
    todosLosDiasHabiles: 'Alle Werktage',
    nuevo: 'Neu',
    tipoLicencia: 'Lizenztyp',
    esconderEdadCumple: 'Mein Alter an meinem Geburtstag verbergen',
    edad: 'Alter',
    nroInterno: 'Interne Nr.',
    email: 'E-Mail',
    enero: 'Januar',
    febrero: 'Februar',
    marzo: 'März',
    abril: 'April',
    mayo: 'Mai',
    junio: 'Juni',
    julio: 'Juli',
    agosto: 'August',
    septiembre: 'September',
    octubre: 'Oktober',
    noviembre: 'November',
    diciembre: 'Dezember',
    delAlumno: 'des Schülers',
    completado: 'Abgeschlossen',
    alerta: 'Alarm',
    eliminado: 'Gelöscht',
    pendiente: 'Ausstehend',
    usuarios: 'Benutzer',
    subidas: 'Uploads',
    cancelado: 'Abgebrochen',
    cancelarSubida: 'Upload abbrechen',
    mias: 'Meine',
    todas: 'Alle',
    reservaEspacios: 'Raumbuchung',
    inventario: 'Inventar',
    buscarDocentePorNombre: 'Lehrer nach Name suchen',
    seleccionarFechaSemana: 'Datum/Woche auswählen',
    horarioDocente: 'Lehrerzeitplan',
    ausencias: 'Abwesenheiten',
    horas: 'Stunden',
    justificada: 'Rechtfertigt',
    injustificada: 'Unrechtfertigt',
    sinAusenciasPeriodo: 'Keine Abwesenheiten im ausgewählten Zeitraum',
    clasesSimultaneas: 'Gleichzeitige Klassen',
    sinCertificado: 'Ohne Zertifikat',
    verCertificado: 'Zertifikat ansehen',
    eliminarArchivosViejos: 'Alte Dateien löschen',
    eliminarArchivosViejosConfirmacion: 'Sind Sie sicher, dass Sie alle Dateien löschen möchten, die älter als 1 Monat sind?',
    noSePodraVolverAtras: 'Diese Aktion kann nicht rückgängig gemacht werden und die Dateien gehen dauerhaft verloren.',
    almacenamientoTreffpunkt: 'Speicherung in Treffpunkt',
    cargando: 'Laden',
    clases: 'Klassen',
    aula: 'Klassenraum',
    reemplazaA: 'Ersetzt',
    hora: 'Uhr',
    suplencias: 'Vertretungen',
    suplencia: 'Vertretung',
    ausente: 'Abwesend',
    sinSuplenciasPeriodo: 'Keine Vertretungen im ausgewählten Zeitraum',
    seleccionarPeriodoExportar: 'Wählen Sie den zweiwöchigen Zeitraum aus, den Sie für den Sektor exportieren möchten',
    exportarLicAusViaExtrAExcel: 'Lizenzen, Abwesenheiten, Reisen und Überstunden nach Excel exportieren',
    exportarExcel: 'Nach Excel exportieren',
    generando: 'Generieren',
    descargar: 'Herunterladen',
    periodo: 'Zeitraum',
    mapasAprendizaje: "Lernkarten",
    instructivoHorariosBackOffice: 'Anleitung für Back Office Zeitpläne',
    documentacion: 'Dokumentation',
    permiso: 'Berechtigung',
    categoria: 'Kategorie',
    subCategoria: 'Unterkategorie',
    seleccionePersona: 'Wählen Sie eine Person aus',
    asignarNuevaPersona: 'Weisen Sie eine neue Person dieser Berechtigung zu',
    asignar: 'Zuweisen',
    asignadoEl: 'Zugewiesen zu',
    sinPersonasAsignadas: 'Keine Personen wurden dieser Berechtigung direkt zugewiesen.',
    confirmarQuitarPersona: 'Sind Sie sicher, dass Sie diese Berechtigung von dieser Person entfernen möchten?',
    nombrePermiso: 'Berechtigungsname',
    personasAsignadasPorRol: 'Personen zugewiesen nach Rolle',
    personasAsignadasPorPermiso: 'Personen zugewiesen nach Berechtigung',
    usuariosSinHorarioOFichadasNoApareceran: 'Benutzer ohne zugewiesener Zeitplan innerhalb der letzten 30 Tage werden nicht erscheinen.',
    recruiting: 'Rekrutierung',
  },
};


const i18n = createI18n({
  locale: 'es', // Idioma por defecto
  fallbackLocale: 'en', // Idioma de respaldo
  messages, // Textos en diferentes idiomas
});

export default i18n;
